import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import { useAlerts } from "context/AlertContext";
import { TUser } from "models/users.models";
import { services } from "services";
import { AlertSeverity } from "utils/constants/alerts.constants";
import { QueryAPIKey } from "utils/constants/api.constants";
import handleRetryFailure from "utils/helpers/handleRetryFailure";
import { TErrorData } from "utils/types";

export default function useCurrentUser() {
  const { t } = useTranslation("common", {
    keyPrefix: "notifications",
  });

  const { showAlert } = useAlerts();

  const {
    data: user,
    error,
    isLoading,
    isError,
    isSuccess,
  } = useQuery<AxiosResponse<TUser>, AxiosError<TErrorData>, TUser>({
    queryKey: [QueryAPIKey.GetCurrentUserBasic],
    queryFn: () => services.user.getCurrentUser().then((res) => res.data),
    retry: handleRetryFailure(() =>
      showAlert({
        severity: AlertSeverity.Error,
        message: t("getCurrentUserFailure"),
      }),
    ),
  });

  return {
    user,
    isLoading,
    isError,
    isSuccess,
    error,
  };
}
